
import { Component, OnChanges, Input, SimpleChanges, OnInit, OnDestroy } from '@angular/core';
import { ProductService } from '../../services/product.service';
import { Category } from '../../../interfaces/category.model';
import { Food } from 'src/interfaces/food.model';
import { Drink } from 'src/interfaces/drink.model';
import { StoplistService } from 'src/app/services/stoplist.service';
import { map, Subject, Subscription, takeUntil, tap } from 'rxjs';
import { NavigationCategoryService } from 'src/app/services/navigation-category.service';


@Component({
    selector: 'app-menu-category',
    templateUrl: './menu-category.component.html',
    styleUrls: ['./menu-category.component.css'],
    standalone: false
})
export class MenuCategoryComponent implements OnInit, OnChanges, OnDestroy {
  constructor(
    private productService: ProductService,
    private navigationCategoryService: NavigationCategoryService,
    private stoplistService: StoplistService,
  ) {
    // Для получения начального списка
    this.stoplistFoods = [];
    this.stoplistDrinks = [];
  }

  @Input() category: Category | null = null;
  @Input() isLastCategory: boolean = false;

  sortedFoods: Food[] = [];
  sortedDrinks: Drink[] = [];
  stoplistFoods: string[];
  stoplistDrinks: string[] = [];

  private destroy$ = new Subject<void>();

  ngOnInit(): void {
    // Subscribe to stoplist foods and drinks
    this.stoplistService.foods$
      .pipe(takeUntil(this.destroy$))
      .subscribe(stoplistFoods => {
        // console.log('CategoryCardComponent | ngOnInit() | subscribe() stoplistFoods: ', stoplistFoods.length);
        this.stoplistFoods = stoplistFoods;
      });

    this.stoplistService.drinks$
      .pipe(takeUntil(this.destroy$))
      .subscribe(stoplistDrinks => {
        // console.log('CategoryCardComponent | ngOnInit() | subscribe() stoplistDrinks: ', stoplistDrinks.length);
        this.stoplistDrinks = stoplistDrinks;
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['category'] && changes['category'].currentValue) {

      // Если категория не активная (не сработал фильтр при загрузке) пропускаем
      if (!this.category?.active) return

      // console.log('MenuCategory | ngOnChanges() | category: ', this.category?.title);

      // foods
      this.productService.foods$.pipe(
        takeUntil(this.destroy$),
        map(foods => foods.filter(food => food.category === this.category!.id)), // Фильтруем по категории
      ).subscribe(filtered => {
        if (filtered.length) {
          this.sortedFoods = filtered.sort((a, b) => a.index - b.index);
          this.navigationCategoryService.addCategory(this.category!);
          // console.log('MenuCategory | ngOnChanges() | subscribe() | foods: ', filtered.map(x => x.title + ' modificators: ' + typeof x.modificators).join(', '));
        } else {
          this.sortedFoods = [];
          if (this.sortedDrinks.length === 0) {
            this.navigationCategoryService.removeCategory(this.category!.id);
          }
        }
      });

      // drinks
      this.productService.drinks$.pipe(
        takeUntil(this.destroy$),
        map(drinks => drinks.filter(drink => drink.category === this.category!.id)), // Фильтруем по категории
      ).subscribe(filtered => {
        if (filtered.length) {
          this.sortedDrinks = filtered.slice().sort((a, b) => a.index - b.index);
          this.navigationCategoryService.addCategory(this.category!);
        } else {
          this.sortedDrinks = [];
          if (this.sortedFoods.length === 0) {
            this.navigationCategoryService.removeCategory(this.category!.id);
          }
        }
      });
    }
  }

  ngOnDestroy(): void {
    // Отписка при уничтожении компонента
    this.destroy$.next();
    this.destroy$.complete();
  }
}
